import React from "react";
import { Link } from "react-router-dom";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Cookies from "js-cookie";
import logoHt from '../src/imagenes/htLogoNaranja.png'
import Login from "./components/Login/login";
import Clients from "./components/Clients/clients";
import ClientsDetail from "./components/Clients/clientsDetail";
import ClientsCreate from "./components/Clients/clientsCreate";
import ClientModify from "./components/Clients/clientsModify";
import Items from "./components/Items/items";
import ItemDetail from "./components/Items/itemDetail";
import ItemsCreate from "./components/Items/itemsCreate";
import ItemModify from "./components/Items/itemModify";
import Documents from "./components/Documents/documents";
import DocumentsCreate from "./components/Documents/documentsCreate";
import DocumentsDetail from "./components/Documents/documentDetail";
import DocumentPut from "./components/Documents/documentPut";
import DocumentModify from "./components/Documents/documentPutCarModify";
import InformesPedidos from "./components/Documents/informesPedido";
import PedidoNuevo from "./components/Documents/pedidoNuevo";
import AprobacionPreOrden from "./components/Documents/aprobacionPreorden";
import Produccion from "./components/Documents/produccion";
import DeleteDocFind from "./components/Documents/deleteDocumentFind";
import DeleteDoc from "./components/Documents/deleteDocumentDetail";
import InDocument from "./components/InDocuments/inDocuments";
import InDocumentId from "./components/InDocuments/inDocumentDetail";
import InDocumentCreate from "./components/InDocuments/inDocumentCreate";
import InDocumentChild from "./components/InDocuments/inDocumetChild";
import Users from "./components/Users/users";
import UsersCreate from "./components/Users/userCreate";
import Home from "./components/Home/home";
import HomeClientes from "./components/Home/homeClientes";
import HomeDocuments from "./components/Home/homeDocuments";
import HomeItems from "./components/Home/homeItem";
import NavBar from "./components/Navbar/navElements";
import DocumentPDF from "./components/Documents/documentPDF";
import Calendario from "./components/Calendar/calendar";
import InformesPresupuestos from "./components/Presupuesto/informesPresupuesto";
import InformePrueba from "./components/Presupuesto/informePrueba";
import DetailPresupuesto from "./components/Presupuesto/detailPresupuesto"; 
import NuevoPresupuesto from "./components/Presupuesto/nuevoPresupuesto";
import PresupuestoModify from "./components/Presupuesto/modificarPresupuesto";
import ProtectedRoutes from "./utils/protectedRoutes";
import PreciosMod from "./components/Presupuesto/preciosMod";





function App() {
  //const dispatch = useDispatch();
  const {isAuthenticated, user} = useSelector(state => state.auth)

  
  
  //console.log(isAuthenticated);
  //console.log(user);
  
  

  return ( 
    <BrowserRouter>       
    <div className="flex bg-blue-950">
      <div className="container w-[180px] h-screen">
        <Link to="/">
          <div className="flex my-4 justify-center"><img className="w-[80px] h-[80px]" src={logoHt}/></div>
          {/* <div className="mt-4 text-[16pt] font-bold text-orange-500">Home</div> */}
          </Link>
          <div className="px-4">
        <NavBar />
        </div>
      </div>
      <Routes>
      <Route element={<ProtectedRoutes roles={['admin', 'user']}/>}>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/clientes" element={<HomeClientes />} />
        <Route exact path="/clientes/listado" element={<Clients />} />
        <Route exact path="/clientes/:id" element={<ClientsDetail />} />
        <Route exact path="/clientes/create" element={<ClientsCreate />} />
        <Route exact path="/clientes/modificar/:id" element={<ClientModify />} />       
        <Route exact path="/documentos" element={<HomeDocuments />} />
        <Route exact path="/documentos/listado" element={<Documents />} />
        <Route exact path="/documentos/:id" element={<DocumentsDetail />} />
        <Route exact path="/documentos/create" element={<DocumentsCreate />} />
        <Route exact path="/documentos/pdf" element={<DocumentPDF />} />
        <Route exact path="/documentos/modificar" element={<DocumentPut />} />
        <Route exact path="/documentos/modificar/:id" element={<DocumentModify />} />
        <Route exact path="/documentos/delete" element={<DeleteDocFind />} />
        <Route exact path="/documentos/delete/:id" element={<DeleteDoc />} />
        <Route exact path="/pedidos/informes" element={<InformesPedidos />} />
        <Route exact path="/pedidos/nuevo" element={<PedidoNuevo />} />
        <Route exact path="/pedidos/aprobacion_pre_orden" element={<AprobacionPreOrden />} />
        <Route exact path="/pedidos/produccion" element={<Produccion />} />
        <Route exact path="/items" element={<HomeItems />} />
        <Route exact path="/items/:id" element={<ItemDetail />} />
        <Route exact path="/items/listado" element={<Items />} />
        <Route exact path="/items/create" element={<ItemsCreate />} />
        <Route exact path="/items/modify" element={<ItemModify />} />
        <Route exact path="/users" element={<Users />} />
        <Route exact path="/users/create" element={<UsersCreate />} />
        <Route exact path="/inDocument" element={<InDocument />} />
        <Route exact path="/inDocument/:id" element={<InDocumentId />} />
        <Route exact path="/inDocument/create" element={<InDocumentCreate />} />
        <Route exact path="/inDocument/saldar" element={<InDocumentChild />} />
        <Route exact path="/calendario" element={<Calendario />} />
      </Route>

        <Route element={<ProtectedRoutes roles={['admin']}/>}>
          <Route exact path="/presupuestos" element={<InformesPresupuestos />} />
          <Route exact path="/presupuestosPrueba" element={<InformePrueba />} />
          <Route exact path="/presupuestos/:id" element={<DetailPresupuesto />} />
          <Route exact path="/presupuestos/nuevo" element={<NuevoPresupuesto />} />
          <Route exact path="/presupuestos/modificar/:id" element={<PresupuestoModify />} />
          <Route exact path="/precios" element={<PreciosMod />} />
        </Route>
        <Route exact path="/login" element={<Login />} />
      </Routes>
      </div>
    </BrowserRouter>
    
  );
}

export default App;

